export class PseudonymSettings {
    constructor(public usePseudonym: boolean,
                public pseudonym: string) {
    }
}
